/**
 * 成绩报告页路由分流。
 *
 * newhsk1-6 走新版成绩报告（NewHskReport），其余试卷继续走老版答题报表
 * （ResultReport）。所有跳转点统一调 reportRouteName，不要各自复制白名单
 * —— 老页里 hsk3levelList 这份魔法数字已经散落在 resultReport.vue 与
 * Introduce.vue 两处，再多几份必然漂移。
 */

// newhsk1-6 的 levelId。与 resultReport.vue:512、Introduce.vue:833 的
// hsk3levelList 同源。
export const NEW_HSK_16_LEVEL_IDS = [31, 32, 33, 34, 35, 36]

/**
 * newhsk1-6 的 level 路由参数值。
 *
 * 入口页（试卷列表、学习历史）手里只有这个字符串、没有 levelId，
 * 所以分流主要靠它；levelId 白名单用于报告页内的二次校验。
 */
export const NEW_HSK_16_LEVELS = [
  'new-hsk1',
  'new-hsk2',
  'new-hsk3',
  'new-hsk4',
  'new-hsk5',
  'new-hsk6',
]

/**
 * 归一化后比较：不同入口给的形态不一致 —— 试卷列表是 query 里的 'new-hsk2'，
 * 学习历史是 level_name.toLowerCase()，可能带空格或下划线。去掉所有非字母数字
 * 再比对，'NEW HSK 2' / 'new_hsk2' / 'new-hsk2' 都能命中。
 *
 * 用等值比对而不是 'new-hsk' 前缀匹配：前缀会把 'new-hsk7-9'（归一化成
 * newhsk79）也算进 newhsk1-6，而 HSK7-9 必须留在老页。
 */
const normalizeLevel = (level) => String(level).toLowerCase().replace(/[^a-z0-9]/g, '')

const NEW_HSK_16_LEVELS_NORMALIZED = NEW_HSK_16_LEVELS.map(normalizeLevel)

export const isNewHsk16 = (levelId) => NEW_HSK_16_LEVEL_IDS.includes(Number(levelId))

export function isNewHsk16Level(level) {
  if (typeof level !== 'string' || !level) return false
  return NEW_HSK_16_LEVELS_NORMALIZED.includes(normalizeLevel(level))
}

/**
 * 该进新版报告还是老版报表。
 *
 * @param {Object} p { level, levelId, examinationType }
 *        level / levelId 给到哪个都行，有一个命中即走新页
 * @returns {String} 路由 name
 */
export function reportRouteName({ level, levelId, examinationType } = {}) {

  // 作业（examinationType=4）的报告语义与模考不同（无"再考一遍"、无付费诊断），
  // 一律留在老页
  if (Number(examinationType) === 4) return 'ResultReport'
  if (isNewHsk16(levelId) || isNewHsk16Level(level)) return 'NewHskReport'
  return 'ResultReport'
}
